import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterBy',
    standalone: false,
})
export class FilterByPipe implements PipeTransform {
    transform(data: any[], property: string, filter: string) {
        const value = filter.toLowerCase();

        return value
            ? data.filter((item) =>
                  item[property].toLowerCase().includes(value),
              )
            : data;
    }
}
